import React, { lazy } from 'react'

const PrivatePolicyPage = lazy(() => import('./PrivatePolicyPage'))

export { PrivatePolicyPage }
